import type { PageCard } from '@/play/pageTypes'
import { SpillCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'spill',
  number: 1,
  title: 'Spill',
  question: 'Is pouring coloured water over a landscape fun to steer?',
  status: 'archived',
  accent: '#cfe9f6',
  CardArt: SpillCardArt,
}
